'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var TextInput = require('../../TextInput/src/TextInput.js');
var GlobalSearch_module = require('../styles/GlobalSearch.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const GlobalSearch = (props) => {
    const { globalFilter, isSearchFocused, setIsSearchFocused, handleGlobalSearch } = props;
    const cx = reactUtils.useStyles(GlobalSearch_module.default);
    return (React__namespace.createElement(TextInput.TextInput, { label: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435", icon: React__namespace.createElement(reactIcons.Search, { color: isSearchFocused ? 'var(--color-B100)' : '' }), className: cx('global-search'), value: globalFilter ?? '', onChange: handleGlobalSearch, onFocus: setIsSearchFocused.on, onBlur: setIsSearchFocused.off }));
};

exports.GlobalSearch = GlobalSearch;
//# sourceMappingURL=GlobalSearch.js.map
